var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "news-wrapper uk-grid-small uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l",
      attrs: {
        "data-uk-height-match": "target: > div > a > .uk-card; row: false",
        "data-uk-grid": "",
      },
    },
    _vm._l(_vm.items, function (item) {
      return _c("div", { key: item.id, staticClass: "news-item" }, [
        _c("a", { attrs: { href: item.url } }, [
          item.image.length
            ? _c(
                "div",
                {
                  staticClass:
                    "uk-card news-image uk-flex uk-flex-center uk-flex-middle",
                },
                [
                  _c("img", {
                    attrs: {
                      "data-src": item.image,
                      width: "380",
                      height: "380",
                      alt: item.title,
                      "data-uk-img": "",
                    },
                  }),
                ]
              )
            : _c("div", { staticClass: "uk-card uk-card-body" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "footer-content" }, [
                  _c("div", { staticClass: "type" }, [
                    _vm._v(_vm._s(item.type)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "date" }, [
                    _vm._v(_vm._s(item.date)),
                  ]),
                ]),
              ]),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }